import {
  faBoxArchive,
  faBoxOpen,
  faCoins,
  faFlask,
  faObjectGroup,
  faPrint,
  faRecycle,
} from '@fortawesome/free-solid-svg-icons';
import { BLEND_RESOURCE_TYPE } from 'src/hooks/useBlendCheck';
import { BLEND_ATTRIBUTE } from 'src/utils/blendAttributes';

/** Every value carries the icon for what it is, matching the rest of QR. */
export const BLEND_ATTRIBUTE_ICONS = {
  [BLEND_ATTRIBUTE.MATERIAL_TYPE]: faObjectGroup,
  [BLEND_ATTRIBUTE.MATERIAL_LOT]: faBoxOpen,
  [BLEND_ATTRIBUTE.USAGE_CYCLES]: faRecycle,
  [BLEND_ATTRIBUTE.POWDER_QUALITY]: faFlask,
};

export const BLEND_RESOURCE_ICONS = {
  [BLEND_RESOURCE_TYPE.CONTAINER]: faCoins,
  [BLEND_RESOURCE_TYPE.PRINTER]: faPrint,
  [BLEND_RESOURCE_TYPE.BATCH]: faBoxArchive,
};

export const getResourceIcon = type => BLEND_RESOURCE_ICONS[type] || faBoxArchive;
